import camelCaseKeys from 'camelcase-keys';
import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import { type UsersAdminFilterData } from 'Admin/Admin.types';

// The nested keys, such as program_type, stay snake_case, as UsersAdminFilterData expects. So only the
// top-level keys are converted, as the Angular page did.
export const adminUsersApi = createApi('adminUsersApi', {
    ...getBackRoyalApiBaseConfig('adminUsersApi', { convertCasing: false }),
    endpoints: builder => ({
        getUsersAdminFilterData: builder.query<UsersAdminFilterData, void>({
            query: () => ({ url: 'users/admin_filters.json' }),
            transformResponse: (response: Record<string, unknown>) =>
                camelCaseKeys(response) as unknown as UsersAdminFilterData,
        }),
    }),
});

export const { useGetUsersAdminFilterDataQuery } = adminUsersApi;
